
<!-- <div class="gt-dashboard-ex" [ngStyle]="{'height': expand ? '100%' : '35px'}"> -->
<div class="gt-dashboard-ex">

  <div class="gt-dashboard-ex-header" >

        <span class="chev pull-left  Appkit4-icon" (click)="expandClose()"
                [ngClass]="{'icon-down-chevron-outline':expand, 'icon-right-chevron-outline':!expand
                            ,'expand-trans':expand}">
        </span>

        <h5 class="diagnostic-table-heading pull-left">{{tableSheet[0].name}}</h5>

        <!-- <div class="action-items">
          <span ><mat-slide-toggle [(ngModel)]="checked" (change)="toggle()"></mat-slide-toggle></span>
          <span> Hide Resolved Diagnostics</span>   -->
         <!--  <span class="Appkit4-icon icon-table-data-outline" matTooltip="View Raw Data" ></span>
          <span class="Appkit4-icon icon-edit-outline" data-toggle="modal"
                (click)="showEditComponent(tableSheet)"
          ></span>    -->
          <!-- <span class="Appkit4-icon icon-expand-outline"></span> -->
        <!-- </div> -->
    </div>
    <div class="gt-dashboard-ex-body" *ngIf="expand" >
          <ng-container>
            @if (!tableSheet[0].sheet.isLoaded) {
              <ap-loading [loadingType]="'circular'" [indeterminate]="true" [compact]="false"></ap-loading>
            }
            @if (tableSheet[0].sheet.isLoaded) {
              <table mat-table [dataSource]="tableSheet[0].sheet.data" matSort class="summary-diagnostic-mat-table">
                @for (entry of visibleTableColumns; track entry.id) {
                  <ng-container [matColumnDef]="entry.id">
                    @if (entry.col.data === null) {
                      <th mat-header-cell *matHeaderCellDef style="width:30px"></th>
                    } @else {
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        <span>{{ entry.col.title }}</span>
                      </th>
                    }
                    <td mat-cell *matCellDef="let rowData" [ngClass]="{'drill-down': entry.col.data == null}">
                      @if ((entry.col.data != null && rowData[entry.col.data] === 'Critical') || (entry.col.data != null && rowData[entry.col.data] === 'Informational')) {
                        <span class="Appkit4-icon"
                          [ngClass]="{'icon-alert-fill': rowData[entry.col.data] === 'Critical',
                                      'icon-information-fill': rowData[entry.col.data] === 'Informational'}"
                          [ngStyle]="{'color': rowData[entry.col.data] === 'Critical' ? '#D04A02' : '#212121',
                                      'margin-right':'10px'}">
                        </span>
                      }
                      @if (entry.col.data == 'FAILCNT') {
                        <span [ngStyle]="{'color':(rowData[entry.col.data] > 0 && rowData.DIAG_MSG == 'Critical') ? '#D04A02' : '#212121'}"
                              (click)="redirectDrillDown(rowData, entry.index)">
                          {{ rowData[entry.col.data] }}
                        </span>
                      }
                      @if (entry.col.data != null && entry.col.data != 'FAILCNT') {
                        <span [ngStyle]="{'color': rowData[entry.col.data] > 0 ? 'red' : 'black'}">
                          {{ rowData[entry.col.data] }}
                        </span>
                      }
                      @if (entry.col.data == null && entry.col.className != undefined) {
                        <span style="padding: 0px 8px 0px 8px" class="Appkit4-icon icon-pencil-outline"
                              [ap-tooltip] [tooltipContent]="template3"
                              [direction]="'bottom'"
                              (click)="showEditComponent(rowData, baseURLs)"></span>
                      }
                    </td>
                  </ng-container>
                }

                <ng-template #template3>
                  <div class="tooltip-inner ap-p-spacing-3 d-block a-min-width-300">
                    <div class="a-font-sm customize-tooltip-text font-weight-normal text-left ap-mt-spacing-2">
                      Click to navigate to the area where you can resolve Diagnostics
                    </div>
                  </div>
                </ng-template>

                <tr mat-header-row *matHeaderRowDef="displayedColumnIds"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnIds"></tr>
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" [attr.colspan]="displayedColumnIds.length" style="text-align: center">
                    No records found
                  </td>
                </tr>
              </table>
            }
          </ng-container>


      <gtw-detail-diag-view (loadDrillDownScreen)="loadDrillDownScreen($event)" *ngIf="showAddEditModalViewer" (afterModalClosed)="afterModalClosed()"></gtw-detail-diag-view>
<!--       <gtw-add-edit *ngIf="showAddEditModalViewer" (afterModalClosed)="afterModalClosed()"></gtw-add-edit>
 -->

